import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20curves%20in%20coral%20peach%20and%20warm%20beige%20tones%2C%20minimalist%20geometric%20overlay%2C%20subtle%20rainbow%20light%20refraction%2C%20gentle%20atmospheric%20glow%2C%20modern%20and%20inclusive%20design%20aesthetic%2C%20no%20people%2C%20abstract%20art%20style&width=1800&height=1200&seq=hero-bg-nantongwang&orientation=landscape"
        alt="男同网 - 温暖包容的社群平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-20">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-md border border-white/20 text-white/90 text-xs font-medium mb-8">
          <i className="ri-rainbow-line text-sm"></i>
          <span>安全 · 包容 · 多元</span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight mb-6">
          找到志同道合的
          <br />
          <span className="text-primary-300">朋友与真实的自己</span>
        </h1>

        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          男同网是专为男同群体打造的综合性平台，提供交友互动、社群交流、生活资讯与权益支持。
          在这里，你可以在安全、包容的环境中，探索真实的自我，遇见真诚的朋友。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/categories"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-primary-500 text-white text-base font-medium hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
          >
            开始探索
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-lg bg-white/10 backdrop-blur-sm border border-white/25 text-white text-base font-medium hover:bg-white/20 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-3 gap-6 max-w-lg mx-auto">
          {[
            { value: '50,000+', label: '社群成员' },
            { value: '600+', label: '优质文章' },
            { value: '98%', label: '用户好评' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white font-heading">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white/40 text-2xl"></i>
      </div>
    </section>
  );
}